import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import actions from "actions";
import constants from "constants";
import validator from "services/validator";
import inputFormatter from "../../../services/userInputFormatter";
import EditSuperhostForm from "../../../components/Admin/Superhosts/EditSuperhostForm";
// import EditSuperhostForm from '../../../components/Admin/Superhost/EditSuperhostForm';

const { UPDATE_SUPERHOST } = constants;

const {
  getSuperhost,
  getStudygroupsAdmin,
  updateSuperhost,
  addValidateError,
  cleanErrors,
} = actions;

class EditSponsor extends Component {
  static propTypes = {
    createUser: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj,
  };

  constructor(props) {
    super(props);
    const superhost = this.props.superhost;
    this.state = {
      superhost: {
        first_name: "",
        last_name: "",
        validFrontend: false,
        host_group_ids: [],
        email: "",
      },
    };
  }

  componentWillReceiveProps(props) {
    if (!_.isEqual(this.state.superhost, props.superhost)) {
      this.setState({
        superhost: {
          ...this.state.superhost,
          ...props.superhost,
        },
      });
    }
  }

  componentWillMount() {
    this.props.cleanErrors();
    this.props.getSuperhost(this.props.params.id);
    this.props.loadStudygroups({}, "all");
  }

  onFieldChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const superhostData = {
      ...this.state.superhost,
      ...{
        [e.target.name]: input,
      },
    };

    this.setState({ superhost: superhostData });
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.props.updateSuperhost(this.state.superhost.id, this.state.superhost);
  };

  // onFieldChange = (e) => {
  //   const superhostData = { ...this.state.superhost,
  //     ...{
  //       [e.target.name]: e.target.value
  //     }
  //   }

  //   this.setState({ superhost: superhostData })//, this.validateUser);
  // }

  render() {
    const { errors, errorsFrontend, studygroups } = this.props;
    const groups = (studygroups || []).map((group) => ({
      value: group.id,
      label: group.title,
    }));
    const outErrors = Object.keys(errorsFrontend || {}).length
      ? errorsFrontend
      : errors;
    return (
      <main className="site--width clearfix-c">
        <h2 className="main_title">Superhost #{this.state.superhost.id}</h2>
        <EditSuperhostForm
          superhost={this.state.superhost}
          onFieldChange={this.onFieldChange}
          onSubmit={this.onSubmit}
          studyGroups={groups}
          errors={outErrors || {}}
          is_admin={true}
        />
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  errors: state.errors[UPDATE_SUPERHOST],
  errorsFrontend: state.errors[`${UPDATE_SUPERHOST}_FRONTEND`],
  superhost: state.superhosts.tmp,
  studygroups: state.studygroups.studygroups.values,
  query: state.studygroups.studygroups.query,
  page: state.studygroups.studygroups.page,
  total_pages: state.studygroups.studygroups.total_pages,
});

const mapDispatchToProps = (dispatch) => ({
  getSuperhost: (id) => dispatch(getSuperhost(id)),
  updateSuperhost: (id, superhost) => dispatch(updateSuperhost(id, superhost)),
  validateUser: (errors) =>
    dispatch(addValidateError(UPDATE_SUPERHOST, errors)),
  loadStudygroups: (query, page) => dispatch(getStudygroupsAdmin(query, page)),
  cleanErrors: () => dispatch(cleanErrors(UPDATE_SUPERHOST)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditSponsor);



// WEBPACK FOOTER //
// ./src/containers/Admin/Superhosts/EditSuperhost.jsx